import { render, staticRenderFns } from "./Cover.vue?vue&type=template&id=e18afba2&scoped=true"
import script from "./Cover.vue?vue&type=script&lang=js"
export * from "./Cover.vue?vue&type=script&lang=js"
import style0 from "./Cover.vue?vue&type=style&index=0&id=e18afba2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e18afba2",
  null
  
)

export default component.exports